import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface MarketingApiHealth {
  rateLimited: boolean;
  sources: string[];
  since: string | null;
}

/**
 * Polls the marketing data-source health endpoint so the dashboard can show a
 * callout when Google's APIs (GA4 / Google Ads) are rate-limited. Polls every
 * 90s so the banner appears and clears without a manual refresh.
 */
export function useApiHealth() {
  return useQuery<MarketingApiHealth>({
    queryKey: ["marketing-api-health"],
    queryFn: () => api.marketing.apiHealth.get(),
    refetchInterval: 90 * 1000,
    staleTime: 60 * 1000,
  });
}
